<template>
  <div class="widget-callport">
    <div class="card">
      <div class="card-header">
       <h5>
          Avui {{ new Date().toLocaleDateString() }} fan escala...
       </h5>
      </div>
      
      <div class="img-icon" v-if="data[0].vars.iconvaixell == 'creuers.svg'">
        <Creuers />
      </div>
      <div class="img-icon" v-if="data[0].vars.iconvaixell == 'tancs.svg'">
        <Tanquers />
      </div>
      <div class="img-icon" v-if="data[0].vars.iconvaixell == 'portacontenidors.svg'">
        <Portacontenidors />
      </div>
      <div class="img-icon" v-if="data[0].vars.iconvaixell == 'ferries.svg'">
        <Ferris />
      </div>
      <div class="img-icon" v-if="data[0].vars.iconvaixell == 'car-carrier.svg'">
        <Carcarrier />
      </div>
      <div class="img-icon" v-if="data[0].vars.iconvaixell == 'granelers.svg'">
        <Granelers />
      </div>
      <div class="img-icon" v-if="data[0].vars.iconvaixell == 'Ro-ro.svg'">
        <Carregaroro />
      </div>
      <div class="img-icon" v-if="data[0].vars.iconvaixell == 'Lo-lo.svg'">
        <Lolo />
      </div>

      <div class="card-body">
        <h1>
          {{ data[0].vars.compte }} {{ data[0].vars.tipusvaixell }}
        </h1>
        <p class="card-text" v-html="this.setSpans(data[0].vars.llistavaixells)">
          
          <!-- {{ data[0].vars.llistavaixells }} -->
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Creuers from './Icons/Creuers.vue';
import Tanquers from './Icons/Tanquers.vue';
import Portacontenidors from './Icons/Portacontenidors.vue';
import Ferris from './Icons/Ferris.vue';
import Carcarrier from './Icons/Carcarrier.vue';
import Granelers from './Icons/Granelers.vue';
import Carregaroro from './Icons/Carregaroro.vue';
import Lolo from './Icons/Lolo.vue';
export default {
  name: 'Callport',
  components: { Creuers, Tanquers, Portacontenidors, Ferris, Carcarrier, Granelers, Carregaroro, Lolo },
  props: {
    data: Array
  },
  methods: {
    setSpans(text){
      let textArray = text.split(',')
      let textOuput = textArray.map(item => `&nbsp;<span class="border rounded">${item}</span>&nbsp;`)
      return textOuput.join('')
    }
  }
}
</script>
